import axios from '../../axios'
import { IBriefDetailData, ICompanyBrief } from './inspection_brief.types'

/**
 * 添加公司简介
 */
export function briefAdd(params: ICompanyBrief) {
    return axios({
        method: 'post',
        url: '/inspection/brief/add',
        data: params
    })
}

/**
 * 详情
 */
export function briefDetail() {
    return axios<IBriefDetailData>({
        method: 'get',
        url: '/inspection/brief/getDetail',
    })
}
